import { makeStyles } from '@material-ui/core/styles'
import { Button, TextField } from '@mui/material'
import { useState } from 'react'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import CloseButton from 'src/components/common/CloseButton'
import LoadingModal from 'src/components/common/LoadingModal'
import { getTokenForQrReport } from 'src/services/individualService'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { PAN_NO_REGEX } from 'src/utils/constants/BuyPolicyMotor'
import { getAge } from 'src/utils/commonMethods'
import { COLORS } from 'src/utils/Themes/colors'
import { useDispatch } from 'react-redux'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { DETAILS } from 'src/utils/constants/BuyPolicy'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const VerifyKycModal = ({
  closeModal,
  verifyKYCFunction,
  pan,
  dateOfBirth,
  quoteDetails,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [proposerKYCDetails, setProposerKYCDetails] = useState({
    panNumber: {
      value: pan?.toUpperCase(),
      error: false,
      errorMessage: null,
    },
    dateOfBirth: {
      value: dateOfBirth,
      error: false,
      errorMessage: null,
    },
  })
  const [loading, setLoading] = useState(false)

  const getErrorValue = (fieldName, value) => {
    switch (fieldName) {
      case DETAILS?.PAN_NUMBER:
        return !PAN_NO_REGEX?.test(value)
      case DETAILS?.DOB:
        return getAge(value) < 18
      default:
        return false
    }
  }

  const getErrorText = (fieldName) => {
    switch (fieldName) {
      case DETAILS?.PAN_NUMBER:
        return DETAILS?.INVALID_PAN
      case DETAILS?.DOB:
        return
      default:
        DETAILS?.AGE_MUST_18
        return ''
    }
  }

  const handleProposerDetailsChange = (event) => {
    setProposerKYCDetails({
      ...proposerKYCDetails,
      [event?.target?.name]: {
        ...proposerKYCDetails[event?.target?.name],
        value: event?.target?.value,
        error: getErrorValue(event?.target?.name, event?.target?.value),
        errorMessage: getErrorText(
          event?.target?.name,
          getErrorValue(event?.target?.name, event?.target?.value)
        ),
      },
    })
  }

  const handleVerify = () => {
    // dispatch(updateProposerDetails(proposerKYCDetails));
    // inside fetchToken call verifyKYCFunction
    fetchToken()
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setLoading(false)
      const token = response?.res?.data?.access_token
      verifyKYCFunction(token, proposerKYCDetails)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.kycModalContainer}>
        <CloseButton
          id='closeButton'
          title='Close'
          handleClose={closeModal}
          classname={classes.clsBtn}
        />
        <div className={classes.titleDiv}>
          <p className={classes.title}>Verify KYC</p>
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.proposerDetails}>
            <div className={classes.inputContent}>
              <TextField
                id='panNumber'
                name='panNumber'
                type='text'
                placeholder='PAN Number *'
                required
                error={proposerKYCDetails?.panNumber?.error}
                helperText={proposerKYCDetails?.panNumber?.errorMessage}
                className={classes.inputTextField}
                value={
                  proposerKYCDetails?.panNumber?.value?.toUpperCase() ?? ''
                }
                onChange={handleProposerDetailsChange}
              ></TextField>
            </div>
            <div className={classes.inputContent}>
              <CustomDatePicker
                id='dateOfBirth'
                name='dateOfBirth'
                placeholder='Date of birth *'
                required
                value={proposerKYCDetails?.dateOfBirth?.value ?? ''}
                error={proposerKYCDetails?.dateOfBirth?.error}
                helperText={proposerKYCDetails?.dateOfBirth?.errorMessage}
                onChange={handleProposerDetailsChange}
                className={classes.inputTextField}
              ></CustomDatePicker>
            </div>
            <div className={classes.buyContainer}>
              <Button
                id='verifyButton'
                variant='contained'
                className={classes.verifyButton}
                disabled={
                  proposerKYCDetails?.panNumber?.error ||
                  proposerKYCDetails?.dateOfBirth?.error
                }
                onClick={handleVerify}
              >
                Verify
              </Button>
              <Button
                id='cancelButton'
                variant='contained'
                className={classes.cancelButton}
                onClick={closeModal}
              >
                Cancel
              </Button>
            </div>
          </div>

          <div className={classes.quoteDetails}>
            <div className={classes.quoteContainer}>
              <div className={classes.quoteSection}>
                <div>
                  <img
                    src={quoteDetails.providerImage}
                    alt='providerImage'
                    className={classes.digitImage}
                  />
                  <div>
                    <span className={classes.digitInput}>
                      {quoteDetails?.providerName}
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.quoteSection}>
                <span className={classes.digitOtherInput}>
                  {quoteDetails?.insuranceName}
                </span>
              </div>
              <div className={classes.quoteSection}>
                <span className={classes.digitBaseInput}>Base Premium</span>
                <span className={classes.digitRate}>
                  {formatToINR(
                    quoteDetails?.basePremiumAmount
                      ? quoteDetails?.basePremiumAmount
                      : quoteDetails?.netPremium
                  )}
                </span>
              </div>
            </div>
            <div className={classes.totalPremium}>
              <span className={classes.premiuSubTitle}>Total Premium </span>
              <span className={classes.premiuSubTitle}>
                {formatToINR(
                  quoteDetails?.premiumAmount
                    ? quoteDetails?.premiumAmount
                    : quoteDetails?.grossTotalPremium
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default VerifyKycModal

const useStyles = makeStyles({
  kycModalContainer: {
    backgroundColor: '#FFFFFF',
    padding: '20px',
  },
  titleDiv: {
    borderBottom: '0.5px solid #D8D8D8',
    marginBottom: '10px',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: COLORS.DARK_PINK,
    textAlign: 'center',
    fontWeight: '600',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    padding: '10px',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  proposerDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '70%',
  },
  quoteDetails: {
    width: '30%',
    padding: '20px 20px',
    background: 'linear-gradient( #EF669B -900%, #FFFFFF 100%)',
  },

  digitItems: {
    marginLeft: '11px',
    marginBottom: '20px',
  },
  digitImage: {
    width: '60px',
    marginBottom: '-5px',
  },
  digitInput: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    color: '#666666 ',
  },
  digitBaseInput: {
    fontFamily: 'Roboto',
    fontSize: '12px',
  },

  digitOtherInput: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    color: '#2BA6C8',
    fontWeight: '600',
  },
  digitCoverRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    // fontWeight:'600',
  },
  digitInputRate: {
    marginBottom: '28px',
    marginLeft: '105px',
  },
  digitRate: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  totalPremium: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '5px 10px',
    borderRadius: '10px',
    backgroundColor: 'white',
    marginTop: '10px',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  premiuSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  premiumRate: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    marginLeft: '142px',
  },
  quoteSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '10px',
    gap: 5,
  },
  updatedText: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    gap: '5px',
    fontSize: '14px',
    opacity: '0.8',
    color: COLORS.DARK_PINK,
  },
  quoteContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '0px 20px',
  },
  verifyButton: {
    background: 'linear-gradient(226.67deg, #73CFEE 34.4%, #5DB2C9 123.77%)',
    color: COLORS.WHITE,
    width: '100px',
    height: '30px',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
  },
  cancelButton: {
    background: 'linear-gradient(226.67deg, #B92250 34.4%, #B92250 123.77%)',
    color: COLORS.WHITE,
    width: '100px',
    height: '30px',
    boxShadow: 'none !important',
    borderRadius: '5px !important',
  },
  buyContainer: { display: 'flex', flexDirection: 'row', gap: 30 },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  clsBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
})
